import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import PopUpPhpto from "@assets/svg/popUpPhpto.svg?react";
import CloseCross from "@assets/svg/close-cross-black.svg?react";
import useBreakPoinst from "@hooks/useBreakPoinst";
import { useTranslation } from "react-i18next";
import { useGetUserDetail } from "../../../../src/services/home/getUserDetail/index";

import {
  ModalWrapper,
  ImageContainer,
  CloseIconWrapper,
  ContentBox,
  Title,
  Description,
  ActionContainer,
  StyledButton,
  StyledImage,
  InlineSpacer,
} from "./styles";

const RemainingDaysPopUp = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  const navigate = useNavigate();
  const { isPhone } = useBreakPoinst();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [open, setOpen] = useState(false);

  const { data } = useGetUserDetail();
  const subscriptionRemainingDays =
    data?.result?.popUpMessage?.subscriptionRemainingDays;
  const displayPopup = data?.result?.popUpMessage?.isDisplay;

  const shouldShowModal = () => {
    const lastShownDate = localStorage.getItem("remainingDaysModalLastShown");
    const today = new Date().toISOString().split("T")[0];
    return lastShownDate !== today;
  };

  const markModalAsShown = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem("remainingDaysModalLastShown", today);
  };

  useEffect(() => {
    if (
      typeof subscriptionRemainingDays === "number" &&
      subscriptionRemainingDays < 4 &&
      displayPopup &&
      shouldShowModal()
    ) {
      setOpen(true);
      markModalAsShown();
    }
  }, [subscriptionRemainingDays]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <>
        <ModalWrapper $isPhone={isPhone} $lang={language}>
          <ImageContainer>
            <CloseIconWrapper $lang={language} onClick={handleClose}>
              <span>
                <CloseCross />
              </span>
            </CloseIconWrapper>
            <StyledImage $isPhone={isPhone} />
          </ImageContainer>

          <ContentBox $isPhone={isPhone}>
            <Title $isPhone={isPhone}>
              {t("MANAGE_PLAN.remaining_trial_days")}
              <InlineSpacer>{subscriptionRemainingDays}</InlineSpacer>
              {t("MANAGE_PLAN.free_trial_ending")}
            </Title>
            <Description $isPhone={isPhone}>
              {t("MANAGE_PLAN.access_data_prompt")}
            </Description>
          </ContentBox>

          <ActionContainer $isPhone={isPhone}>
            <StyledButton
              onClick={() => {
                navigate("/choose-plan");
              }}
              variant="contained"
              color="primary"
              $isPhone={isPhone}
            >
              {t("MANAGE_PLAN.add_payment_info")}
            </StyledButton>
          </ActionContainer>
        </ModalWrapper>
      </>
    </Modal>
  );
};

export default RemainingDaysPopUp;
